import { X } from "lucide-react";
import type { LeadLabel } from "@school-sales-ai/shared";
import { labelChipClasses } from "@/lib/stage-colors";

type Props = {
  label: LeadLabel;
  // When provided, renders a small × to remove the label from the lead.
  onRemove?: () => void;
};

export function LabelChip({ label, onRemove }: Props): React.JSX.Element {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium whitespace-nowrap ${labelChipClasses(label.color)}`}
    >
      {label.name}
      {onRemove && (
        <button
          type="button"
          aria-label={`Quitar etiqueta ${label.name}`}
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          className="-mr-0.5 rounded-full opacity-60 hover:opacity-100"
        >
          <X className="h-3 w-3" />
        </button>
      )}
    </span>
  );
}
